export const wizardSteps = [
  {
    canNavigate: true,
    completed: true,
    steps: 0,
    title: "SCHEME ONBOARD",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 1,
    title: "REQUIRED DOCUMENT",
  },
];
